// extracted by mini-css-extract-plugin
export default {"bellIcon":"BrowseNotification_bellIcon__PINjZ"};